// @flow
import * as React from 'react';
import styled, {css} from 'styled-components';

type Props = {
  onClick: () => void,
  children?: React.Node,
  rootEvents?: boolean,
};

export default function GuideMessageContainer(props: Props): React.Element<any> {
  return (
    <GuideWrapper dataevents={props.rootEvents} onClick={props.onClick}>
      {props.children}
    </GuideWrapper>
  );
}

const GuideWrapper = styled.button`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  ${props => props.dataevents !== true && css`
  pointer-events: none !important;

  > div {
    p {
      pointer-events: auto;
    }
    [style*='opacity: 0'] > p {
      pointer-events: none !important;
    }
  }
  `}
`;
